module.exports = "<aside [class.collapsed]=\"isCollapsed\" [class.animate]=\"doAnimateCollapse\">\n    <a *ngIf=\"isCollapsible\" class=\"collapse-button\" (click)=\"toggleCollapsed()\"></a>\n    <div class=\"panel-content-wrapper\">\n        <ng-content select=\"[panel-content]\"></ng-content>\n    </div>\n</aside>\n\n<div class=\"content\">\n    <ng-content select=\"[content]\"></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/collapsible-panel/collapsible-panel.component.html
// module id = 1o4S
// module chunks = 5